import * as React from "react";
import { RouteComponentProps } from "react-router";
import { ReportUrl } from "@common";
import { AudienceReportPage } from "./AudienceReportPage";
import { CreativeReportPage } from "./CreativeReportPage";
import { DynamicReportsPage } from "./DynamicReportsPage";
import { GeographicReportPage } from "./GeographicReportPage";

export function ReportPage(props: RouteComponentProps<any>) {
    const match = ReportUrl.match(props.location, true);

    if (match.isMatched) {
        switch (match.params.tab) {
            case "audience":
                return <AudienceReportPage {...props} />;
            case "creative":
                return <CreativeReportPage {...props} />;
            case "dynamic":
                return <DynamicReportsPage {...props} />;
            case "geographic":
                return <GeographicReportPage {...props} />;
        }
    }

    return null;
}
